import React, {Component} from 'react';
import {fetchFavoriteItems, resetFavoriteData} from '../actions/FavoriteAppActions'
import {connect} from "react-redux";
import {bindActionCreators} from 'redux';
import Favorite from '../components/Favorite';


class FavoritePage extends Component {

  constructor(props) {
    super(props);
  }
  componentDidMount() {
      if (this.props.attrs.num_items && this.props.attrs.num_items.value){
        this.props.resetFavoriteData({count: this.props.attrs.num_items.value});
      }
  }

  render() {
    return (
        <div className="ncartdetail-container">
          <div className="ncard">
            <Favorite/>
          </div>
        </div>
    );
  }
}

const mapStateToProps = state => (state);

const mapDispatchToProps = dispatch => bindActionCreators({fetchFavoriteItems, resetFavoriteData}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FavoritePage);